<script>
import countlyVue from '../../compat/vue-core';
import FormCommons from '../form/commons';
import i18n from '../../../../i18n';

export default countlyVue.components.BaseComponent.extend({
  name: 'ClyFormDialog',
  inheritAttrs: false,
  mixins: [
    FormCommons.MultiStepForm,
    countlyVue.mixins.Modal,
  ],
  props: {
    ignoreDefaultPaddings: { type: Boolean, required: false, default: false },
    noHeader: { type: Boolean, required: false, default: false },
    noFooter: { type: Boolean, required: false, default: false },
    isOpened: { type: Boolean, required: true },
    name: { type: String, required: true },
    title: { type: String, required: false, default: '' },
    saveButtonLabel: { type: String, required: false, default: '' },
    cancelButtonLabel: { type: String, required: false, default: i18n.tc('common.cancel') },
    closeFn: { type: Function },
    hasCancelButton: { type: Boolean, required: false, default: true },
    toggleTransition: {
      type: String,
      default: 'stdt-fade',
    },
    type: { type: String, default: 'success' },
  },
  computed: {
    rootClasses() {
      return {
        'is-mounted': this.isMounted,
        'is-open': this.isOpened,
      };
    },
  },
  data() {
    return {
      isToggleable: true,
    };
  },
  watch: {
    isOpened(newState) {
      if (!newState) {
        this.reset();
      } else {
        this.$emit('open');
      }
      this.setModalState(newState);
    },
  },
  methods: {
    doClose() {
      this.$emit('close', this.name);
      if (this.closeFn) {
        this.closeFn();
      }
    },
    onClickOutside() {
      this.doClose();
    },
    escKeyEvent() {
      this.doClose();
    },
    onViewEntered() {
      this.$refs.rootEl.focus();
    },
  },
});
</script>
<template>
  <transition
    :name="toggleTransition"
    @enter="onViewEntered"
  >
    <div
      v-show="isOpened"
      ref="rootEl"
      v-click-outside="onClickOutside"
      class="cly-vue-formdialog"
      tabindex="0"
      :class="rootClasses"
      @keydown.esc="escKeyEvent"
    >
      <div
        v-if="!noHeader"
        class="cly-vue-formdialog__header bu-p-4"
      >
        <h3 class="color-cool-gray-100">
          {{ title }}
        </h3>
      </div>
      <div
        v-scroll-shadow
        class="cly-vue-formdialog__steps-container bg-warm-gray-10"
        :class="{'is-multi-step':isMultiStep, 'bu-px-4': !ignoreDefaultPaddings}"
      >
        <div class="bu-columns bu-is-gapless bu-is-mobile">
          <div class="bu-column bu-is-12">
            <slot
              name="default"
              v-bind="passedScope"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!noFooter"
        class="cly-vue-formdialog__footer bu-p-4"
      >
        <div class="cly-vue-formdialog__controls-left-pc">
          <slot
            name="controls-left"
            v-bind="passedScope"
          />
        </div>
        <div
          v-if="isMultiStep"
          class="cly-vue-formdialog__buttons is-multi-step bu-is-justify-content-flex-end bu-is-flex"
        >
          <el-button
            v-if="hasCancelButton && currentStepIndex === 0"
            type="secondary"
            size="small"
            :disabled="isSubmitPending"
            @click="doClose"
          >
            {{ cancelButtonLabel }}
          </el-button>
          <el-button
            v-if="currentStepIndex > 0"
            type="secondary"
            size="small"
            :disabled="isSubmitPending"
            @click="prevStep"
          >
            {{ $t('common.drawer.previous-step') }}
          </el-button>
          <el-button
            v-if="!isLastStep"
            size="small"
            :type="type"
            :class="{'is-disabled':!isCurrentStepValid}"
            :disabled="isSubmitPending"
            @click="nextStep"
          >
            {{ $t('common.drawer.next-step') }}
          </el-button>
          <el-button
            v-if="isLastStep"
            :loading="isSubmitPending"
            size="small"
            :class="{'is-disabled':!isSubmissionAllowed}"
            :type="type"
            :disabled="isSubmitPending"
            @click="submit"
          >
            {{ saveButtonLabel }}
          </el-button>
        </div>
        <div
          v-if="!isMultiStep"
          class="cly-vue-formdialog__buttons is-single-step bu-is-justify-content-flex-end bu-is-flex"
        >
          <el-button
            v-if="hasCancelButton"
            type="secondary"
            size="small"
            :disabled="isSubmitPending"
            @click="doClose"
          >
            {{ cancelButtonLabel }}
          </el-button>
          <el-button
            :loading="isSubmitPending"
            size="small"
            :type="type"
            :class="{'is-disabled':!isSubmissionAllowed}"
            :disabled="isSubmitPending"
            @click="submit"
          >
            {{ saveButtonLabel }}
          </el-button>
        </div>
      </div>
    </div>
  </transition>
</template>
